import { computed, observable, makeObservable } from "mobx";
import { CategoriaMinuta as ICategoriaMinuta } from '../modelo';
import EscaninhoStore from "./EscaninhoStore";


class CategoriasStore {
    categorias: ICategoriaMinuta[] = [];
    carregandoCategorias: boolean = false;
    modalComplementosMovimento: boolean = false;
    descricaoCategoriaModalMovimento = '';

    constructor() {
        makeObservable(this, {
            categorias: observable,
            carregandoCategorias: observable,
            modalComplementosMovimento: observable,
            descricaoCategoriaModalMovimento: observable,
            processos: computed,
            identificadorProcesso: computed
        });
    }

    get processos() {
        return EscaninhoStore.processosSelecionados;
    }

    get identificadorProcesso() {
        return this.processos.length > 0 ? this.processos[0].identificadorProcesso : undefined;
    }
}

export default new CategoriasStore();